import { render, staticRenderFns } from "./EventComments.vue?vue&type=template&id=0a14b050&"
import script from "./EventComments.vue?vue&type=script&lang=js&"
export * from "./EventComments.vue?vue&type=script&lang=js&"
import style0 from "./EventComments.vue?vue&type=style&index=0&id=0a14b050&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports